import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Footer, Loader} from '../../components';
import {redirectToTakeYourPicture} from '../../ducks/Navigate';
import {updateDadosPessoais, biometriaAdicionar} from '../../ducks/Customer';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';
class ConfirmYourPicture extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.ConfirmYourPicture.title,
    );
    if (!this.props.dadosPessoais.biometria)
      this.props.redirectToTakeYourPicture();
  }

  handleFinish = (event) => {
    event.preventDefault();

    const request = {
      chave: this.props.chave,
      ...this.props.dadosPessoais,
    };
    this.props.biometriaAdicionar(request);
  };

  renderContentButton = () => {
    return (
      <Footer
        backHandle={() => {
          const prop = 'biometria';
          const value = null;
          this.props.updateDadosPessoais({prop, value});
          this.props.redirectToTakeYourPicture();
        }}
        nextHandle={this.handleFinish}
        textBack="Tirar outra"
        hideBtnNext={this.props.hideBtnNext}
      />
    );
  };

  render() {
    return (
      <div className="div-confirm-your-picture">
        <div className="content">
          <div className="header">
            <p>Confirme sua foto</p>
          </div>
          <img
            src={this.props.dadosPessoais.biometria}
            className="img-src"
            alt="Self"
          />
        </div>
        {this.renderContentButton()}
        <Loader />
      </div>
    );
  }
}

const mapStateToProps = ({customer, loader}) => {
  const {chave, dadosPessoais, hideBtnNext} = customer;
  console.log(dadosPessoais);
  return {chave, dadosPessoais, hideBtnNext};
};
export default connect(mapStateToProps, {
  redirectToTakeYourPicture,
  updateDadosPessoais,
  biometriaAdicionar,
})(ConfirmYourPicture);
